import { render, staticRenderFns } from "./customerVendorRatingLayout.vue?vue&type=template&id=9a869d08&"
import script from "./customerVendorRatingLayout.vue?vue&type=script&lang=js&"
export * from "./customerVendorRatingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a869d08')) {
      api.createRecord('9a869d08', component.options)
    } else {
      api.reload('9a869d08', component.options)
    }
    module.hot.accept("./customerVendorRatingLayout.vue?vue&type=template&id=9a869d08&", function () {
      api.rerender('9a869d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/customerVendorRatingLayout.vue"
export default component.exports